import type { PhoneNumberQuerySchema } from '@/_schemas/phone-numbers';

export type PhoneNumberProps = {
  value: PhoneNumberQuerySchema[] | null;
  onChange: (type: 'DELETE' | 'ADD' | 'UPDATE' | 'SORT') => (value: PhoneNumberQuerySchema[]) => void;
  isEditable?: boolean;
  isSortable?: boolean;
};

export const phoneNumberIncludeKey = (v = '') => {
  const key = v ? `${v}.` : '';
  return `${key}phone_numbers.country.flag`;
};
